/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgTruck48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M24 37.5h22.712L46.5 40H24v-2.5zm0 0H1.287L1.5 40H24v-2.5zm7.986-15.708H16.014v-2.21L8 18.966V16.5s2.992 1.845 16 2.463c13.008-.619 16-2.463 16-2.463v2.466l-8.014.616v2.21z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M39.5 40H45v3.434a1.224 1.224 0 01-1.222 1.223h-3.056a1.222 1.222 0 01-1.222-1.223V40zm-31 0H3v3.434a1.224 1.224 0 001.223 1.223h3.054A1.222 1.222 0 008.5 43.434V40z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M27.756 13.794A4.254 4.254 0 0131.75 11c1.983 0 3.624 1.255 4.087 3.073'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M16.499 23v-.57c-.036-1.723-1.074-2.93-2.535-2.93H5.035C3.55 19.5 2.5 20.75 2.5 22.522V34.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M24.288 22.5h-9.196C13.385 22.5 12 23.856 12 25.526V34.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M3.06 13v.432c0 1.142.925 2.068 2.067 2.068h3.151'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M36 26.5H12.5M36 30.506c-4.689-.005-18.855-.01-23.5 0M26.091 19.292H21.91'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M24.003 5v9.252M9.5 14.573l1.916-7.339A2.99 2.99 0 0114.31 5h9.694-.006 9.694a2.99 2.99 0 012.892 2.234l1.917 7.34'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M7.5 19l.469-2.111a3.306 3.306 0 012.879-2.57c2.195-.114 6.207-.246 13.149-.246h.008c6.942 0 10.953.132 13.147.249a3.303 3.303 0 012.876 2.568c.242 1.075.472 2.11.472 2.11M31.501 23v-.57c.036-1.723 1.074-2.93 2.535-2.93h8.928c1.487 0 2.536 1.25 2.536 3.022V34.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M23.712 22.5h9.195c1.708 0 3.093 1.356 3.093 3.026V34.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M44.94 13v.432a2.068 2.068 0 01-2.067 2.068h-3.151'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M47 35.199a.699.699 0 00-.699-.699H1.7a.699.699 0 00-.699.699V39.3c0 .386.313.699.698.699h44.603a.699.699 0 00.699-.699V35.2zM42.506 21.5a2.498 2.498 0 00-2.494 2.5c0 1.38 1.117 2.5 2.494 2.5A2.498 2.498 0 0045 24c0-1.38-1.117-2.5-2.494-2.5zm-37.012 0A2.498 2.498 0 017.988 24c0 1.38-1.118 2.5-2.494 2.5A2.498 2.498 0 013 24c0-1.38 1.117-2.5 2.494-2.5zM42.5 9.3a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v2.9a.8.8 0 01-.8.8h-2.9a.8.8 0 01-.8-.8V9.3zm-37 0a.8.8 0 00-.8-.8H1.8a.8.8 0 00-.8.8v2.9a.8.8 0 00.8.8h2.9a.8.8 0 00.8-.8V9.3z'
      />
    </svg>
  );
}

export default SvgTruck48;
